import { render, staticRenderFns } from "./movie-session.vue?vue&type=template&id=38d67073&scoped=true&"
import script from "./movie-session.vue?vue&type=script&lang=js&"
export * from "./movie-session.vue?vue&type=script&lang=js&"
import style0 from "./movie-session.vue?vue&type=style&index=0&id=38d67073&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d67073",
  null
  
)

export default component.exports